/** Více informací ve *story* **Design/Styl/Témata – Témata komponent**. */
export enum ComponentTheme {
    default = "default",
    dark = "dark",
    inverted = "inverted",
    light = "light",
}
